<template>
  <TopBar />
  <main class="container">
    <div class="row">
      <div class="col-12 col-md-11 col-lg-9 mx-auto text-center mt-4 mt-md-5">
        <div class="mb-5">
          <h1 class="h6 badge bg-primary rounded-pill mb-4">Oops! </h1>
          <p class="h1 mb-4">{{ error.statusCode }}</p>
          <p class="mb-1 fw-bold">{{ error.message }}</p>
        </div>
          <button class="btn btn-primary fw-bold text-white" @click="handleError">Back to homepage</button>
      </div>
    </div>
  </main>
  <Footer />
</template>

<script setup>
import TopBar from "~/components/TopBar.vue";

const props = defineProps({
  error: Object
})

const handleError = () => clearError({ redirect: '/' })
useHead({
  title: 'Error',
  htmlAttrs: {
    lang: 'en',
    'data-bs-theme': 'dark',
  }
})
</script>